<template>
  <a-pagination
    :show-quick-jumper="true"
    show-size-changer
    :current="pagination.currentPage"
    :total="pagination.total"
    :page-size="pagination.pageSize"
    :page-size-options="pageSizes"
    :show-total="(total, range) => `${pageNTxt[0]} ${total} ${pageNTxt[1]} ${ pagination.currentPage } / ${ Math.ceil(pagination.total / pagination.pageSize) } ${pageNTxt[2]}`"
    @showSizeChange="onShowSizeChange"
    @change="onPageChange"
  >
    <template
      slot="buildOptionText"
      slot-scope="props"
      style="border:solid"
    >
      <span>{{ props.value }}{{ $t('message["1201"]') }}</span>
    </template>
  </a-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pagination: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    pageSizes () {
      const { pageSizes = [] } = this.pagination
      return pageSizes.map(item => item + '')
    },
    pageNTxt () {
      return this.$t('message["393"]').split('|')
    }
  },
  methods: {
    onPageChange (pageNumber) {
      this.pagination.currentPage = pageNumber
      this.$emit('change', this.pagination)
    },
    onShowSizeChange (current, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.currentPage = 1
      this.$forceUpdate()
      this.$emit('change', this.pagination)
    }
  }
}
</script>

<style lang="scss">
/* table 分页 */
.ant-table-pagination {
  margin-right: 20px !important;
}
.ant-select-dropdown-content {
  padding-top: 8px;
  padding-bottom: 8px;
}
.ant-pagination {
  margin: 24px 0 56px;
  text-align: right;
}
.ant-pagination-total-text {
  float: left;
  padding-left: 16px;
  color: #b3b3b3;
}
.ant-pagination-options {
  margin-left: 8px;
}
.ant-pagination-options-quick-jumper {
  height: 32px;
  line-height: 32px;
}
.ant-pagination-options-quick-jumper input {
  height: 32px;
}
</style>
